import { StoreonModule } from 'storeon'
import { Events, State } from '../../interfaces'

export const atcModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    flagInfoCall: false,
    arrTelephonyId: [],
    informationSuccessCall: null
  }))

  store.on('flagInfoCall/change', (state, event) => {
    return {
      flagInfoCall: event
    }
  })

  store.on('arrTelephonyId/add', (state, event) => {
    if (state.flagInfoCall) {
      return {
        arrTelephonyId: [...state.arrTelephonyId, event]
      }
    }
    return {
      arrTelephonyId: [...state.arrTelephonyId, event],
      informationSuccessCall: [...state.arrTelephonyId, event][0]
    }
  })
  
  store.on('arrTelephonyId/remove', (state, event) => {
    const arr = state.arrTelephonyId.filter(
      (item: Record<string, any>) => item.telephony_id !== event
    )
    return {
      arrTelephonyId: arr,
      informationSuccessCall: arr.length !== 0 ? arr[0] : null
    }
  })
}
